import { inject }                      from '@angular/core';
import { ResolveFn }                   from '@angular/router';
import { Observable }                  from 'rxjs';
import { SessionService, UserSession } from './session.service';

export const sessionResolver: ResolveFn<UserSession> = (): Observable<UserSession> => {
  return inject(SessionService).loadSession();
};
